import React from 'react';
import { NavLink, Navigate } from 'react-router-dom';
import { formatPhoneNumberIntl } from 'react-phone-number-input';

import { Avatar, MCButton } from 'src/components/basic';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';
import BaseComponent from 'src/components/BaseComponent';

import Personal from 'src/pages/main/Settings/Personal';
import Notification from 'src/pages/main/Settings/Notification';
import Security from 'src/pages/main/Settings/Security';

import { withRouter, userFullName, lang, scssVariables, permissions } from 'src/helpers';

import model from './model';

class Settings extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  render() {
    const user = model.getUser() || {};
    let name = userFullName(user);
    let avatar = (user.avatar || '').toString().replace('/full_', '/350_');

    const list = permissions.ACTIVE_PAGE_LIST.filter(
      (p) => p.path.includes('settings') && !!p.title
    );
    return (
      <div className={'mc-container-content mc-settings'}>
        <div className={'mc-container-content__body-gap horizontal'}>
          <div className={'mc-container-content__body-gap-left'}>
            <div className={'mc-fix-wrap'}>
              <div className={'mc-menu-info mc-p20'}>
                <div className={'mc-flex-10-col mc-flex-center'}>
                  <Avatar image={avatar} text={name} width={90} height={90} />
                  <div className={'mc-value-620'}>{name}</div>
                  {user.username && <div className={'mc-label-418'}>{user.username}</div>}
                </div>
                <div className={'mc-flex-10-col'} style={{ width: '100%' }}>
                  {user.phoneNumber && (
                    <div className={'mc-flex'}>
                      <div className={'mc-value-418 mc-grow'}>{lang.t('Phone')}</div>
                      <div className={'mc-label-418 mc-text-truncate'}>
                        {formatPhoneNumberIntl(user.phoneNumber.toString())}
                      </div>
                    </div>
                  )}
                  <div className={'mc-flex mc-b2t mc-pt10'}>
                    <div className={'mc-value-418 mc-grow'}>{lang.t('Email')}</div>
                    <div className={'mc-label-418 mc-text-truncate'}>{user.email}</div>
                  </div>
                </div>

                <div className={'mc-flex-10-col'} style={{ width: '100%' }}>
                  {list.map((item, index) => (
                    <NavLink key={index} to={item.path} exact={'true'}>
                      <SVGIcon
                        iconname={item.icon}
                        width={40}
                        fill={scssVariables['colors-mc-heading']}
                      />
                      <span className={'mc-text-truncate'}>
                        {lang.t(typeof item.title === 'string' ? item.title : item.title(user))}
                      </span>
                    </NavLink>
                  ))}
                </div>
                <div className={'mc-flex'} style={{ width: '100%' }}>
                  <MCButton
                    label={'Logout'}
                    medium
                    radius
                    quaternary
                    light
                    flex
                    onClick={() => {
                      model.emit('logout');
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={'mc-flex-col mc-grow'}>{this.props.children}</div>
        </div>
      </div>
    );
  }
}

const MainContainer = withRouter(Settings);

export default {
  ADMIN_SETTING_PERSONAL_PAGE: {
    name: 'admin_setting_personal_page',
    path: '/admin/settings/personal',
    icon: BASE_ICONS.PERSONAL_INFORMATION,
    title: 'Personal Information',
    element: (
      <MainContainer>
        <div className={'mc-main-content'}>
          <Personal />
        </div>
      </MainContainer>
    )
  },
  ADMIN_SETTING_SECURITY_PAGE: {
    path: '/admin/settings/security',
    icon: BASE_ICONS.CHANGE_PASSWORD,
    title: 'Email and Password',
    name: 'admin_settings_security_page',
    element: (
      <MainContainer>
        <Security />
      </MainContainer>
    )
  },
  ADMIN_SETTING_NOTIFICATION_PAGE: {
    path: '/admin/settings/notification',
    icon: BASE_ICONS.NOTIFICATION,
    title: 'Notification',
    name: 'admin_setting_notification_page',
    element: (
      <MainContainer>
        <div className={'mc-main-content'} style={{ display: 'flex' }}>
          <Notification />
        </div>
      </MainContainer>
    )
  },
  ADMIN_SETTINGS_REDIRECT: {
    name: 'admin_settings_redirect',
    path: '/admin/settings',
    element: <Navigate to={'/admin/settings/personal'} />
  }
};
